(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('HubspotDealSearch', HubspotDealSearch);

    HubspotDealSearch.$inject = ['$resource'];

    function HubspotDealSearch($resource) {
        var resourceUrl =  'api/_search/hubspot-deals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
